export const SELECT_TACHE = 'SELECT_TACHE'

export const selectTache = (tache, panelType) => dispatch => dispatch({
	type: SELECT_TACHE,
	currentTache: tache,
	panelType: panelType
})